import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Text, CopyIcon } from 'components/common/ui';
import { PermissionsGate } from '@components';
import { ENTITIES_PERMISIONS } from 'components/common/PermissionsGate/constants';
import EditIcon from '@mui/icons-material/Edit';
import styles from './servicePointSidebar.styles';

export const EditableField = ({
  label,
  value,
  loading,
  onEdit,
  field,
  showEdit = true,
  children,
}) => {
  const handleCopyToClipboard = (copiedValue) => {
    navigator.clipboard.writeText(copiedValue);
  };
  return (
    <Box>
      <Box sx={styles.fieldLabel}>{label}</Box>
      <Box sx={styles.bankContainer}>
        <Box sx={styles.fieldValueContainer}>
          {children || (
            <Text loading={loading} sx={styles.fieldValue}>
              {value || '-'}
            </Text>
          )}
          {label === 'IBAN:' && value && (
            <IconButton
              disabled={loading}
              onClick={() => handleCopyToClipboard(value)}
              sx={styles.copyButton}
            >
              <CopyIcon />
            </IconButton>
          )}
        </Box>
        {showEdit && (
          <PermissionsGate entity={ENTITIES_PERMISIONS.WriteServicePoints}>
            <IconButton
              size="small"
              onClick={() => onEdit(field)}
              sx={styles.editButton}
            >
              <EditIcon sx={{ fontSize: '16px' }} />
            </IconButton>
          </PermissionsGate>
        )}
      </Box>
    </Box>
  );
};
